// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
/* giving direct value instead of variable(header-FontWeight, default-FontName) due to signInPage calls before App.js */
.invalidDomain {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f9f9f9;
  gap: 14px;
  height: 100vh;
  justify-content: space-between;
  position: relative;
  z-index: 2011;
}

.footerImage {
  width: 100%;
}

.invalidDomain .button.MuiButton-root,
.invalidDomain .button.MuiButton-root:hover {
  background-color: #1f3c88;
  color: #ffffff;
  letter-spacing: 0px;
}

.invalidDomain .button.MuiButton-root,
.invalidDomain .button.MuiButton-root,
.invalidDomain__userPermissiontring,
.invalidDomain__userPermissionInsufficientString,
.invalidDomain__userPermissionAccount {
  font-family: Segoe UI;
}

.invalidDomain__userPermissiontring,
.invalidDomain__userPermissionInsufficientString,
.invalidDomain__userPermissionAccount {
  font-size: 24px;
  font-style: normal;
  letter-spacing: 0px;
  line-height: normal;
}

.invalidDomain .button.MuiButton-root,
.invalidDomain .button.MuiButton-root {
  border-radius: 4px;
  text-transform: none;
  font-size: 16px;
}

.invalidDomain__userPermissiontring,
.invalidDomain__userPermissionInsufficientString,
.invalidDomain .button.MuiButton-root,
.invalidDomain .button.MuiButton-root {
  font-weight: 600;
}

.invalidDomain__userPermissiontring {
  font-style: normal;
  line-height: 32px;
  color: #1f3c88;
  padding-top: 14px;
}

.invalidDomain__footerImage {
  bottom: 0px;
  position: fixed;
  width: 100%;
}

.invalidDomain__pageImageGroup {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f9f9f9;
  gap: 14px;
  justify-content: space-between;
  padding-top: 105px;
}

.invalidDomain__image404 {
  padding-top: 151px;
}

.invalidDomain__backButton {
  padding-top: 10px;
}

.userPermission .button.MuiButton-root,
.userPermission .button.MuiButton-root {
  border-radius: 4px;
  width: 147px;
  height: 42px;
  z-index: 3;
}

.invalidDomain__userPermissionInsufficientString {
  font-style: normal;

  line-height: 32px;
  position: relative;
  z-index: 1;
}

.invalidDomain__userPermissionAccount {
  font-style: normal;
  font-weight: 400;

  line-height: 32px;
  position: relative;
  z-index: 1;
}

img.imageavator {
  height: 70px;
}

img.marstonGroupImage {
  width: 18.229vw;
}

img.Image404 {
  width: 30.885vw;
}

@media screen and (min-width: 400px) and (max-width: 1100px) {
  .pageNotFound__pageImageGroup {
    padding-top: 60px;
  }

  img.imageavator {
    height: 60px;
  }

  .invalidDomain__image404 {
    padding-top: 86px;
  }
}

@media screen and (min-width: 1300px) and (max-width: 1380px) {
  .pageNotFound__pageImageGroup {
    padding-top: 30px;
  }

  img.imageavator {
    height: 60px;
  }

  .invalidDomain__image404 {
    padding-top: 100px;
  }
}

@media screen and (min-width: 1400px) and (max-width: 1700px) {
  .invalidDomain__image404 {
    padding-top: 95px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/msalProviderScreen/InvalidDomainPage.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD,uHAAuH;AACvH;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;;;EAGE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;;EAElB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;;EAEhB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n/* giving direct value instead of variable(header-FontWeight, default-FontName) due to signInPage calls before App.js */\n.invalidDomain {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: #f9f9f9;\n  gap: 14px;\n  height: 100vh;\n  justify-content: space-between;\n  position: relative;\n  z-index: 2011;\n}\n\n.footerImage {\n  width: 100%;\n}\n\n.invalidDomain .button.MuiButton-root,\n.invalidDomain .button.MuiButton-root:hover {\n  background-color: #1f3c88;\n  color: #ffffff;\n  letter-spacing: 0px;\n}\n\n.invalidDomain .button.MuiButton-root,\n.invalidDomain .button.MuiButton-root,\n.invalidDomain__userPermissiontring,\n.invalidDomain__userPermissionInsufficientString,\n.invalidDomain__userPermissionAccount {\n  font-family: Segoe UI;\n}\n\n.invalidDomain__userPermissiontring,\n.invalidDomain__userPermissionInsufficientString,\n.invalidDomain__userPermissionAccount {\n  font-size: 24px;\n  font-style: normal;\n  letter-spacing: 0px;\n  line-height: normal;\n}\n\n.invalidDomain .button.MuiButton-root,\n.invalidDomain .button.MuiButton-root {\n  border-radius: 4px;\n  text-transform: none;\n  font-size: 16px;\n}\n\n.invalidDomain__userPermissiontring,\n.invalidDomain__userPermissionInsufficientString,\n.invalidDomain .button.MuiButton-root,\n.invalidDomain .button.MuiButton-root {\n  font-weight: 600;\n}\n\n.invalidDomain__userPermissiontring {\n  font-style: normal;\n  line-height: 32px;\n  color: #1f3c88;\n  padding-top: 14px;\n}\n\n.invalidDomain__footerImage {\n  bottom: 0px;\n  position: fixed;\n  width: 100%;\n}\n\n.invalidDomain__pageImageGroup {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: #f9f9f9;\n  gap: 14px;\n  justify-content: space-between;\n  padding-top: 105px;\n}\n\n.invalidDomain__image404 {\n  padding-top: 151px;\n}\n\n.invalidDomain__backButton {\n  padding-top: 10px;\n}\n\n.userPermission .button.MuiButton-root,\n.userPermission .button.MuiButton-root {\n  border-radius: 4px;\n  width: 147px;\n  height: 42px;\n  z-index: 3;\n}\n\n.invalidDomain__userPermissionInsufficientString {\n  font-style: normal;\n\n  line-height: 32px;\n  position: relative;\n  z-index: 1;\n}\n\n.invalidDomain__userPermissionAccount {\n  font-style: normal;\n  font-weight: 400;\n\n  line-height: 32px;\n  position: relative;\n  z-index: 1;\n}\n\nimg.imageavator {\n  height: 70px;\n}\n\nimg.marstonGroupImage {\n  width: 18.229vw;\n}\n\nimg.Image404 {\n  width: 30.885vw;\n}\n\n@media screen and (min-width: 400px) and (max-width: 1100px) {\n  .pageNotFound__pageImageGroup {\n    padding-top: 60px;\n  }\n\n  img.imageavator {\n    height: 60px;\n  }\n\n  .invalidDomain__image404 {\n    padding-top: 86px;\n  }\n}\n\n@media screen and (min-width: 1300px) and (max-width: 1380px) {\n  .pageNotFound__pageImageGroup {\n    padding-top: 30px;\n  }\n\n  img.imageavator {\n    height: 60px;\n  }\n\n  .invalidDomain__image404 {\n    padding-top: 100px;\n  }\n}\n\n@media screen and (min-width: 1400px) and (max-width: 1700px) {\n  .invalidDomain__image404 {\n    padding-top: 95px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
